import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { IFilterComponent, SearchFilter } from "../../../../infrastructure/iFilter-component";
import { FilterService } from "../../../../services/filter.service";
import { AuthService } from "../../../../services/auth.service";
import { FilterRecordService } from "../../../../services/filter-record.service";
import { CashDeskService } from "../../../../services/cash-desk.service";
import { PatientSearch } from "../../../../model/patient/patient-search";



@Component({
  selector: 'cash-desk-open-filter',
  templateUrl: './cash-desk-open-filter.component.html',
  styleUrls: ['./cash-desk-open-filter.component.css']
})

export class CashDeskOpenFilterComponent implements IFilterComponent, OnInit {

  form: FormGroup;
  @ViewChild('formElement', {static: false}) formElement: ElementRef;

  constructor(private formBuilder: FormBuilder
    , private filterService: FilterService
    , private authService: AuthService
    , private cashDeskService: CashDeskService
    , private filterRecordService: FilterRecordService) {

    this.form = this.formBuilder.group({
      Name: ['']
    });
  }

  get f() { return this.form.controls; }

  getSearchFilters(): SearchFilter[] {
    let requiredTags: string[] = [];

    return this.filterRecordService.convertToSearchFilters(this.form, requiredTags);
  }

  async saveFilters() {
    this.filterRecordService.saveFilters("CashDeskOpenFilterComponent", this.form);
  }

  setFilters(): boolean {
    return this.filterRecordService.setFilters("CashDeskOpenFilterComponent", this.form);
  }

  async search(): Promise<any> {
    return await this.cashDeskService.getCashDeskOpenSearchItems(this.form.controls.Name.value);
  }

  async ngOnInit() {

  }
}
